module.exports = __webpack_public_path__ + "img/img141.1ef1e64a.png";